import React from 'react'
import * as THREE from 'three'
import Superface from '../Superface'
import {isMobile} from '../kit'
import TWEEN, { Tween, Easing } from '@tweenjs/tween.js'
import MapControls from '../etc/three-modules/controls/MapControls'
import ZoomControls from './_ZoomControls'


const CAMERA_Z_MAX = 160;
const CAMERA_Z_MIN = 10;
const CAMERA_Z = 20;

const PLANE_SCALE_X = 5.3
const GRID_Z = 0
const GRID_GUTTER = 5

export default class MaterialsGrid extends React.Component{

    mouse = { x : 0, y: 0 }
    planes = []
    targetMesh = false
    lastCameraX = 0
    
    constructor(props){
        super(props)
        this.frame = 0

        this.start = this.start.bind(this)
		this.stop = this.stop.bind(this)
        this.animate = this.animate.bind(this)
        this.handleResize = this.handleResize.bind(this)
        // this.handleKeyDown = this.handleKeyDown.bind(this)
        this.onMouseDown = this.onMouseDown.bind(this)
        this.onMouseUp = this.onMouseUp.bind(this)
        this.handleMouseMove = this.handleMouseMove.bind(this)
        this.state = {

        }
    }

    //
    // ─── LIFE CYCLE ─────────────────────────────────────────────────────────────────
    //

    componentWillMount(){
        
        
        this.initScene()
        
        if( this.props.materialsImagesLoaded ){
            this.loadImages( this.props.materials )
        }
        this.setState({
            ...this.state, mounted : false, ready : false, leave : false
        })
        this.start()

    }

    // shouldComponentUpdate(){
    //     // return false
    // }

    componentDidMount() {
    
		window.addEventListener('mousemove', this.handleMouseMove)
		window.addEventListener('resize', this.handleResize)
        window.addEventListener('keydown', this.handleKeyDown )
       
        this.mount.appendChild(this.renderer.domElement)
        this.mount.addEventListener('mousedown', this.onMouseDown)
        this.mount.addEventListener('mouseup', this.onMouseUp)
        
        this.setState({
            ...this.state, mounted : true
        })
        
        if( this.props.active ){
            this.controls.activate()
        }else{
            this.controls.dispose()
        }

    }

    componentWillReceiveProps(new_props){
        
        // console.log(new_props.active)
        // If fetching materials is done
        if( new_props.materialsImagesLoaded && this.props.materialsImagesLoaded !== new_props.materialsImagesLoaded ){
            this.loadImages(new_props.materials)
        }

        if( this.props.kindsFilters !== new_props.kindsFilters &&
            !new_props.kindsFilters.isEmpty()
        ){
            this.initPlanesAnimation()
        }

        if( new_props.active !== this.props.active){
            if( new_props.active ){
                this.controls.activate()
            }else{
                this.controls.dispose()
            }
        }

        if( new_props.isOnSingle !== this.props.isOnSingle ){
            if( new_props.isOnSingle ){
                this.setState({ ...this.state, ready:false, leave : false })
            }else if( this.props.isOnSingle ){
                this.setState({ ...this.state, ready:true, leave : false })
            }
        }

    }
    
    componentWillUnmount(){
        this.stop()
        this.controls.dispose()
        this.controls = null
        if( this.timeoutResize )  window.clearTimeout( this.timeoutResize )
        if( this.timeoutMount )  clearTimeout( this.timeoutMount )
        if( this.timeoutScroll ) window.clearTimeout( this.timeoutScroll )
        window.removeEventListener('mousemove', this.handleMouseMove)
        window.removeEventListener('resize', this.handleResize)
        this.mount.removeEventListener('mousedown', this.onMouseDown)
        this.mount.removeEventListener('mouseup', this.onMouseUp)
    }

    //
    // ─── INIT 3D ────────────────────────────────────────────────────────────────────
    //

    initScene(){
        // console.log('------ INIT SCENE --------------')
        this.scene = new THREE.Scene()
        this.scene.background = new THREE.Color(255,255,255) 
        this.camera = new THREE.PerspectiveCamera( 35, window.innerWidth / window.innerHeight, 0.1, 1000 )
        
        this.camera.tweenEnter = new Tween ({ value : 0 })
        .to({ value : 1 }, 1200)
        .easing( Easing.Quadratic.Out )
        .onUpdate( tween => {
            this.camera.animProgress = tween.value
        })
        .onComplete( tween => { tween.value = 0 } )

        this.controls = this.setControls(this.camera)
        this.renderer = new THREE.WebGLRenderer({ antialias: true })
        this.renderer.setSize(window.innerWidth, window.innerHeight)
    }

    setControls(camera){
        
            let controls = new MapControls( camera );
            // controls.zoomSpeed = 0.3;
            controls.minDistance = CAMERA_Z_MIN;
            controls.maxDistance = CAMERA_Z_MAX;
            

            controls.dynamicDampingFactor = 0.2;
            return controls
    }

    initPlanesGroup(){
        this.planeGroup = new THREE.Object3D()
        this.planeGroup.lastPos = { x : this.planeGroup.position.x, y : this.planeGroup.position.y, z : 0 }
        this.planeGroup.tween = new Tween ({ value : 0 })
        .to({ value : 1 }, 400)
        .easing( Easing.Quadratic.InOut )
        .onUpdate( tween => {
            this.planeGroup.animProgress = tween.value
        })
        .onComplete( tween => { tween.value = 0 } )
    }

    // initPlanesGroupAnimation(){
    //     // console.log('init group animation')
    //     this.planeGroup.shouldAnim = true
    //     this.planeGroup.tween.start()
    // }

    loadImages(materials){
        
        this.planes = []
        this.imagesLoaded = 0
        this.imagesToLoad = 0
        
        this.initPlanesGroup()
        Superface.setLoading(true)
        materials.forEach( (matiere, i) => {
            
            // console.log( i + ' : ' + matiere.slug + ' : ' +  matiere.image.thumb_path )
            const path = Superface.assetUrl(matiere.image.thumb_path)
            
            if( path != undefined ){
        
                this.imagesToLoad += 1
                var texture = new THREE.TextureLoader().load( 
                    path,
                    (texture) => {
                        
                        this.imagesLoaded += 1
                        texture.anisotropy = this.renderer.getMaxAnisotropy()
                        var planeMaterial = new THREE.MeshBasicMaterial( { map: texture, transparent : path.includes('.png') } );
                        var geometry = new THREE.PlaneGeometry( 1, 1 );
                        var plane = new THREE.Mesh( geometry, planeMaterial )
                        
                        plane.ratio = texture.image.width / texture.image.height
                        // plane.targetScale = { x : PLANE_SCALE_X, y : PLANE_SCALE_X / plane.ratio }
                        plane.targetScale = { x : PLANE_SCALE_X, y : PLANE_SCALE_X / plane.ratio }
                        
                        // plane.scale.x = PLANE_SCALE_X
                        // plane.scale.y = PLANE_SCALE_X
                        plane.scale.x = plane.targetScale.x
                        plane.scale.y = plane.targetScale.y
                        
                        plane.slug = matiere.slug
                        let kind = Superface.getMaterialKindById( matiere.material_kind._id )
                        // console.log( matiere.material_kind )
                        plane.name = {
                            fr : kind.name,
                            en : kind.name_en
                        }
                        plane.linkSlug = kind.slug
                        plane.imagePath = matiere.image.path
                        plane.tween = new Tween ({ value : 0 })
                        .to({ value : 1 }, 400)
                        .easing( Easing.Cubic.InOut )
                        .onUpdate( tween => {
                            plane.animProgress = tween.value
                        }).onComplete( tween => { tween.value = 0 } )
                    
                        plane.lastScale = plane.targetScale

                        this.planeGroup.add(plane)
                        
                        this.planes[i] = plane
                        if( this.imagesLoaded === Math.round(this.imagesLoaded / 2 ) ){
                            Superface.setloadProgress(0.6)
                        }
                        // console.log( i + ' : ' + this.imagesLoaded + '/' + this.imagesToLoad )
                        
                        if( this.imagesLoaded >= this.imagesToLoad ){
                            
                            if( !Superface.IS_MOBILE_OR_TABLET ){
                                
                                this.timeoutMount = setTimeout( () => { 
                                
                                    // this.camera.lastPos = this.camera.position
                                    // this.initCameraAnimation()
                                    this.materialsReady() 

                                }, 1400 ) 

                            }else{
                                this.camera.position.setZ( CAMERA_Z )
                                this.materialsReady() 
                            }
                            
                        }
                        
                    }
                );
            }   
        })
        
        
    }

    initCameraAnimation(){
        this.controls.enabled = false
        this.camera.shouldAnim = true
        // this.camera.tweenEnter.start()
    }

    // setInitialCameraPosition(){
    //     this.
    // }

    // setGridPositions(){

    //     let window_ratio = window.innerWidth / window.innerHeight
    //     let frames_count = this.planes.length
    //     let n_col_square = Math.ceil( Math.sqrt( this.planes.length ) )
        
    //     const ROW_LENGTH =  Math.ceil( n_col_square / window_ratio )
    //     const COL_LENGTH =  this.planes.length / ROW_LENGTH
        
    //     let index = 0
        
    //     for( var j = 0; j < ROW_LENGTH + 1; j++ ){
    //         for( var i = 0; i < COL_LENGTH - 1; i ++){
    //             if( this.planes[index] ){
                    
    //                 this.planes[index].gridPos = {
    //                     x : i * ( PLANE_SCALE_X + GRID_GUTTER ) + ( 0.5 - Math.random()) * PLANE_SCALE_X ,
    //                     y : - j * ( PLANE_SCALE_X + GRID_GUTTER ) + ( 0.5 - Math.random()) * PLANE_SCALE_X ,
    //                     z : GRID_Z - Math.random() * 20
    //                 }
                    
    //                 this.planes[index].position.setX( this.planes[index].gridPos.x )
    //                 this.planes[index].position.setY( this.planes[index].gridPos.y )
    //                 this.planes[index].position.setZ( this.planes[index].gridPos.z )
    //                 // this.planes[index].lastPos = this.planes[index].gridPos
                    
    //             }
    //             index += 1
    //         }
    //     }

    //     // const plane_scaleX = this.planes[0].scale.x
    //     const frame_height = PLANE_SCALE_X + GRID_GUTTER
    //     const limitPanX = frame_height * ( COL_LENGTH - 1 ) / 2 - GRID_GUTTER * 0.5
    //     const limitPanY = frame_height * ( ROW_LENGTH + 1 ) / 2 - GRID_GUTTER * 0.5
        
    //     this.controls.minPanX = - limitPanX
    //     this.controls.maxPanX = limitPanX
    //     this.controls.minPanY = - limitPanY
    //     this.controls.maxPanY = limitPanY
        
    //     this.planeGroup.gridPos = {
    //         x : - limitPanX,
    //         y : limitPanY,
    //         z : 0
    //     }
        
    // }
    setGridPositions(){

        let window_ratio = window.innerWidth / window.innerHeight
        let n_col_square = Math.round( Math.sqrt( this.planes.length ) )
        
        const COL_LENGTH =  Math.floor( n_col_square * window_ratio )
        let row_num = 0
        let col_num = 0
        
        this.planes.forEach( (plane, i) => {
            
            if( col_num == COL_LENGTH ){
                col_num = 0
                row_num += 1
            }
            
            plane.gridPos = {
                x : col_num * ( PLANE_SCALE_X + GRID_GUTTER ) + ( 0.5 - Math.random()) * PLANE_SCALE_X ,
                y : - row_num * ( PLANE_SCALE_X + GRID_GUTTER ) + ( 0.5 - Math.random()) * PLANE_SCALE_X ,
                z : GRID_Z - Math.random() * 20
            }

            // plane.gridPos = {
            //     x : col_num * ( PLANE_SCALE_X + GRID_GUTTER ) ,
            //     y : - row_num * ( PLANE_SCALE_X + GRID_GUTTER ) ,
            //     z : GRID_Z
            // }

            // if( setPosition ){
            plane.position.setX( plane.gridPos.x )
            plane.position.setY( plane.gridPos.y )
            plane.position.setZ( plane.gridPos.z )
            plane.lastPos = plane.position
            // }
            col_num += 1

        })
        
        const frame_height = PLANE_SCALE_X + GRID_GUTTER
        const limitPanX = frame_height * ( COL_LENGTH ) / 2 - GRID_GUTTER
        const limitPanY = frame_height * ( row_num ) / 2
        
        const margin = 8
        this.controls.minPanX = - limitPanX - margin
        this.controls.maxPanX = limitPanX + margin
        this.controls.minPanY = - limitPanY - margin
        this.controls.maxPanY = limitPanY + margin
        
        this.planeGroup.gridPos = {
            x : - limitPanX,
            y : limitPanY,
            z : 0
        }

    }

    setTargetScale(){
        this.planes.forEach( (plane,i) => {
            // if( i === this.currentTimelineProjectIndex && this.mode === TIMELINE ){
                
            //     plane.targetScale = {
            //         x : PLANE_SCALE_X * MAGNIFICATION,
            //         y : ( PLANE_SCALE_X * MAGNIFICATION ) / plane.ratio
            //     }
            // }else{
            if( plane.targetScale.x !== PLANE_SCALE_X ){
                plane.targetScale = {
                    x : PLANE_SCALE_X,
                    y : PLANE_SCALE_X / plane.ratio
                }
            }
            // }
        })
    }

    materialsReady(){
        this.camera.position.setZ( CAMERA_Z )
        this.scene.add( this.planeGroup )
        this.setTargetScale()
        this.setGridPositions()
        this.planeGroup.position.x = this.planeGroup.gridPos.x
        this.planeGroup.position.y = this.planeGroup.gridPos.y

        Superface.setLoading(false)
        this.setState({
            ...this.state, ready : true
        })
    }

    initPlanesAnimation(mounting = false){
       
        this.planes.forEach( (plane, i) => {
            plane.shouldAnim = true
        })
       
    }

    handleResize() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize( window.innerWidth, window.innerHeight );
        this.sceneDimension = this.project(window.innerWidth, window.innerHeight)
        this.setGridPositions()
        this.planeGroup.position.x = this.planeGroup.gridPos.x
        this.planeGroup.position.y = this.planeGroup.gridPos.y
    }
    

    onMouseDown(e){
        
        this.mouseDownTime = new Date()
        
        if( this.planes.length === this.props.materials.length ){
            
            const intersect = this.checkBrowserMouseIntersection( this.mouse.x, this.mouse.y, this.planes )
        
            if(!intersect || intersect[0] === undefined ) return
            let obj = intersect.first().object
            this.targetMesh = obj
        }

    }

    onMouseUp(e){
       
        if( !this.targetMesh ) return

        const now = new Date()
		const timeDif = (now.getTime() - this.mouseDownTime.getTime()) / 1000
        const shortClick = timeDif < 0.3 ? true : false
        
        if(shortClick && this.targetMesh.slug !== undefined ){
            
            let active = false
            this.props.kindsFilters.forEach( kind => {
                if( kind.slug === this.targetMesh.linkSlug && kind.active ){
                    active = true
                }
            })
            if( !active ) return

            Superface.setCursor('default')
            this.controls.dispose()
            Superface.setKindFeaturedImagePath( this.targetMesh.imagePath )
            this.setState({
                ...this.state, leave : true
            })
            
            Superface.mapLeaving(true)
            this.timeoutLeave = setTimeout(()=>{
                Superface.mapLeaving(false)
                Superface.goTo( Superface.uri('matieres') + '/' + this.targetMesh.linkSlug )
                this.targetMesh = null
            }, 400)
        }
        
    }

    handleMouseMove(e){
        if( !this.planes || !this.scene.children.length || this.props.isOnSingle || !this.state.ready ) return
        
        this.mouse.x = e.pageX
        this.mouse.y = e.pageY
        
       if( this.planes.length === this.props.materials.length ){
            const intersect = this.checkBrowserMouseIntersection( e.pageX, e.pageY, this.planes )
            if( intersect || intersect[0] !== undefined ){
                let plane = intersect.first().object
                
                let active = false
                this.props.kindsFilters.forEach( kind => {
                    if( kind.slug === plane.linkSlug && kind.active ){
                        active = true
                    }
                })
                if( !active ) return

                Superface.setKindTitle( plane.name[Superface.app().lang] )
                Superface.setCursor('pointer')
                document.getElementById('kind-title').style.opacity = 1
            }else{
                if( Superface.app().cursor !== 'default' ){
                    Superface.setCursor('default')
                    document.getElementById('kind-title').style.opacity = 0
                }
            }
        }

    }

    
    //
    // ─── ANIMATE ────────────────────────────────────────────────────────────────────
    //
 
    start() {
		if (!this.frameId) this.frameId = requestAnimationFrame(this.animate)
    }
    
    stop() {
		cancelAnimationFrame(this.frameId)
	}

    moveObject(obj, target_coord, deceleration){
        // console.log(target_coord)
        let offset = {
            x : ( target_coord.x - obj.lastPos.x),
            y : ( target_coord.y - obj.lastPos.y),
            z : ( target_coord.z - obj.lastPos.z)
        }
        const Z = obj.lastPos.z + offset.z * deceleration 
        const X = obj.lastPos.x + offset.x * deceleration 
        const Y = obj.lastPos.y + offset.y * deceleration 
       
        obj.position.x = X
        obj.position.y = Y
        obj.position.z = Z

    }
    

    animate(){
        
        if( this.props.isOnSingle ) return this.frameId = window.requestAnimationFrame(this.animate)
        
        if( this.controls && this.controls.enabled ) this.controls.update()
        
        if( this.planes && this.planeGroup ){
            // console.log( this.camera.position.x, this.camera.position.y )
            if( this.planes.length === this.props.materials.length ){
                
                this.planes.forEach( (plane, i) => {
                    if( plane.shouldAnim ){
                            
                        let active = false
                        this.props.kindsFilters.forEach( kind => {
                            if( kind.slug === plane.linkSlug && kind.active ){
                                active = true
                            }
                        })

                        if( !active ){
                            this.planeGroup.remove( plane )
                        }else{
                            this.planeGroup.add( plane )
                        }
                            
                        plane.shouldAnim = false

                    }
                })

            }
        }

        this.lastCameraX = this.camera.position.x
        this.renderer.render(this.scene, this.camera)
        this.frameId = window.requestAnimationFrame(this.animate)

    }

    project(x, y, targetZ){
		var vector = new THREE.Vector3();
		
		vector.set(
			( x / window.innerWidth ) * 2 - 1,
			- ( y / window.innerHeight ) * 2 + 1,
			0.5 );
		
		vector.unproject( this.camera );
		
		var dir = vector.sub( this.camera.position ).normalize();
		
		var distance = (( targetZ ? targetZ : 0 ) - this.camera.position.z) / dir.z;
		
		var pos = this.camera.position.clone().add( dir.multiplyScalar( distance ) );
		return pos
    }
    
    checkBrowserMouseIntersection( mouseX, mouseY, threeObject){

		if(!this.camera || !this.renderer || !this.scene )
			return false

		if(!this.raycaster) 
			this.raycaster = new THREE.Raycaster();

		let mouse = {
			x : ( mouseX / this.renderer.domElement.clientWidth ) * 2 - 1,
			y : - ( mouseY / this.renderer.domElement.clientHeight ) * 2 + 1
		}
		let intersects
		this.raycaster.setFromCamera( mouse, this.camera );
		if( threeObject && ( threeObject instanceof Array || threeObject === this.scene.children )){
			intersects = this.raycaster.intersectObjects( threeObject )
		}else if (threeObject) {
			intersects = this.raycaster.intersectObject( threeObject )
		}
		return intersects.length ? intersects : false        
    }

    renderControls(){

        if( !this.props.isOnSingle ){
            return <ZoomControls onClickPlus={() => { this.controls.zoomPlus() }} onClickMinus={() => { this.controls.zoomMinus() }} />
        }else{
            return <span></span>
        }
    }

	render() {
        const margin = ( Superface.IS_MOBILE_OR_TABLET ? '2rem' : '2rem' )

		return (
            
            <div className={ ( this.state.ready ? 'map-loaded ' : '') + (this.state.leave ? 'map-leave' : '' )}>

                <div
                    id="three-map-container"
                    style={{ width: '100%', height: '100%' }}
                    ref={(mount) => { this.mount = mount }}
                />

                <div style={{position:'absolute', bottom: margin, right: margin, zIndex:400}}>
                    {this.renderControls()}
                </div>
            
            </div>
		)
    }
    
}


// WEBPACK FOOTER //
// ./src/components/MaterialsGrid.js